module.exports = new __parcel__URL__("Luke_FI.0eba34cb.png").toString();